import { Box, Paper, Typography } from '@mui/material';
import { Labeled } from 'react-admin';
import { Chip } from '@mui/material';
import { useRecordContext } from 'react-admin';
import { TagInput } from '@/components/TagInput';
import { TextInput } from 'react-admin';

const CUSTOM_REPORT_TITLE_VALID_TAGS = ['user.prompt'] as const;

export const CustomReportTitleRulesetEditor = ({
  isDirtyRef,
}: {
  isDirtyRef?: React.MutableRefObject<boolean>;
}) => {
  const record = useRecordContext();
  const docId = record?.id ?? record?._id;

  return (
    <>
      {!!docId && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            mb: 2,
          }}
        >
          <Labeled label="ID">
            <Chip label={docId.toString()} />
          </Labeled>
        </Box>
      )}

      <Paper sx={{ p: 3, mb: 3, width: '100%' }} elevation={1}>
        <Typography variant="h6" gutterBottom>
          Custom report title template
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Use placeholder <code>user.prompt</code> for the therapist&apos;s prompt
          (transcript or typed). Filled at runtime when generating a list title.
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TagInput
            source="customReportTitleTemplate.systemMessage"
            label="System message"
            validTags={CUSTOM_REPORT_TITLE_VALID_TAGS as unknown as string[]}
            markup="{{__id__}}"
            placeholder="System instructions for title generation..."
            fullWidth
          />
          <TagInput
            source="customReportTitleTemplate.userPromptTemplate"
            label="User prompt template"
            validTags={CUSTOM_REPORT_TITLE_VALID_TAGS as unknown as string[]}
            markup="{{__id__}}"
            placeholder="User prompt with {{user.prompt}}..."
            fullWidth
          />
          <TextInput
            source="customReportTitleTemplate.jsonSchemaText"
            label="JSON schema (optional)"
            multiline
            minRows={6}
            fullWidth
            helperText="JSON object for structured output (e.g. title field). Leave empty to use plain-text response."
          />
        </Box>
      </Paper>
    </>
  );
};
